import axios from "axios";
import { API_URL } from "../const";

export const userSignIn = (loginData: JSON) => {
  const data = {
    userLoginDataToken: loginData,
  };
  const url = `${API_URL}userLoginVerify`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/** ************** USER AUTH CHECK START *************** */
export const authUserVerification = (authLogVerifiy: JSON) => {
  const data = {
    UserCheckAuth: authLogVerifiy,
  };
  const url = `${API_URL}userAuthVerification`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ************** USER AUTH CHECK END *************** */

/** ************** FORGOT PASSWORD START *************** */
export const forgotPasswordUpdate = (forgotData: JSON) => {
  const data = {
    forgotPasswordToken: forgotData,
  };
  const url = `${API_URL}verifyForgotPassword`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ************** FORGOT PASSWORD END *************** */

/** ************** UPDATE USER PASSWORD START *************** */
export const updateUserPasswordCall = (encodeData: JSON) => {
  const data = {
    UpdateUserPasswordToken: encodeData,
  };
  const url = `${API_URL}updateUserPassword`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ************** UPDATE USER PASSWORD END *************** */

/** ************** UPDATE COMPANY LOGIN DETAILS START *************** */
export const userCompanyLoginDetailsGet = (listData: any) => {
  const data = {
    GetCompanyLoginDetailsToken: listData,
  };
  const url = `${API_URL}fetchLoginCompanyDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ************** UPDATE COMPANY LOGIN DETAILS END *************** */

/** ************** 2FA LOGIN STEP-2 (verify the 6-digit code) *************** */
export const verifyTotpLogin = (encodeData: JSON) => {
  const data = {
    VerifyLoginTotpToken: encodeData,
  };
  const url = `${API_URL}Totp/VerifyLogin`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
